var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareGreenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.32971,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#C7F2C6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.32971,
    y: 4.5,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E9FAE8",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1211 29.1075C37.3652 28.8982 37.4873 28.7936 37.532 28.6691C37.5712 28.5598 37.5712 28.4403 37.532 28.331C37.4873 28.2065 37.3652 28.1019 37.1211 27.8926L28.6503 20.632C28.2301 20.2718 28.02 20.0917 27.8421 20.0873C27.6875 20.0835 27.5398 20.1514 27.4421 20.2713C27.3297 20.4092 27.3297 20.6859 27.3297 21.2394V25.5347C25.195 25.9081 23.2413 26.9898 21.7894 28.6139C20.2065 30.3846 19.3309 32.676 19.3297 35.051V35.663C20.3791 34.3989 21.6892 33.3766 23.1705 32.666C24.4764 32.0395 25.8881 31.6684 27.3297 31.5706V35.7607C27.3297 36.3141 27.3297 36.5909 27.4421 36.7288C27.5398 36.8487 27.6875 36.9166 27.8421 36.9128C28.02 36.9084 28.2301 36.7283 28.6503 36.3681L37.1211 29.1075Z",
    stroke: "#259C22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareGreenIcon);
export default __webpack_public_path__ + "static/media/ShareGreenIcon.2e3b3d19717b11e4d47881114707b972.svg";
export { ForwardRef as ReactComponent };